import { z } from 'zod';

export const CardBrandSchema = z.enum([
  'VISA',
  'MASTERCARD',
  'ELO',
  'AMEX',
  'HIPERCARD',
  'OTHER',
  'ANY',
]);

export const CardAcquirerSchema = z.enum([
  'STONE',
  'CIELO',
  'REDE',
  'GETNET',
  'PAGBANK',
  'MERCADO_PAGO',
  'SUMUP',
  'INFINITEPAY',
  'OTHER',
  'ANY',
]);

export const ConcreteCardBrandSchema = z.enum([
  'VISA',
  'MASTERCARD',
  'ELO',
  'AMEX',
  'HIPERCARD',
  'OTHER',
]);

export const ConcreteCardAcquirerSchema = z.enum([
  'STONE',
  'CIELO',
  'REDE',
  'GETNET',
  'PAGBANK',
  'MERCADO_PAGO',
  'SUMUP',
  'INFINITEPAY',
  'OTHER',
]);

export const CardFeeRateItemSchema = z.object({
  method: z.enum(['CREDIT_CARD', 'DEBIT_CARD']),
  cardBrand: CardBrandSchema,
  acquirer: CardAcquirerSchema,
  installmentCount: z.number().int().nonnegative(),
  feePercentBps: z.number().int().nonnegative(),
});

export const UpsertPlaceCardFeeRatesBodySchema = z.object({
  rows: z.array(CardFeeRateItemSchema),
});

export const GetPlaceCardFeeRatesResponseSchema = z.object({
  rows: z.array(CardFeeRateItemSchema),
});

export type CardBrand = z.infer<typeof CardBrandSchema>;
export type CardAcquirer = z.infer<typeof CardAcquirerSchema>;
export type ConcreteCardBrand = z.infer<typeof ConcreteCardBrandSchema>;
export type ConcreteCardAcquirer = z.infer<typeof ConcreteCardAcquirerSchema>;
export type CardFeeRateItem = z.infer<typeof CardFeeRateItemSchema>;
export type UpsertPlaceCardFeeRatesBody = z.infer<typeof UpsertPlaceCardFeeRatesBodySchema>;
export type GetPlaceCardFeeRatesResponse = z.infer<typeof GetPlaceCardFeeRatesResponseSchema>;
